export default "__VITE_ASSET__f4dc244e__"